
import { defineComponent, inject } from "vue";
import RepairWorkMap from "modules/construction-work/components/RepairWorkMap.vue";
import { Store } from "modules/construction-work/src/Store";
import {
    IncidentsData,
    WorksData,
} from "modules/construction-work/src/Common/interface";
import Skeleton from "./components/Skeleton.vue";
import Tabs from "./components/Tabs.vue";
import Filter from "./components/Filter.vue";
import WorkList from "./components/WorkList.vue";
import IncidentList from "./components/IncidentList.vue";

export default defineComponent({
    name: "ConstructionWorkPage",
    components: {
        RepairWorkMap,
        Skeleton,
        Tabs,
        Filter,
        WorkList,
        IncidentList,
    },
    props: {
        isArchiveMode: {
            type: Boolean,
        },
    },
    data() {
        return {
            loading: true,
            works: {
                total: 0,
                list: [],
            } as WorksData,
            incidents: {
                total: 0,
                list: [],
            } as IncidentsData,
            isCombinedMode: false,
            isShowCW: true,
            isShowIncident: false,
            _blockCW: null as HTMLElement | null,
            _blockIncident: null as HTMLElement | null,
            lastAppliedFilters: [] as any[],
            // Сохраненное состояние для каждой вкладки
            savedCWState: null as any,
            savedIncidentState: null as any,
        };
    },
    methods: {
        onUpdateWorkTotal(newTotal: number) {
            this.works.searchTotal = newTotal;
        },
        onUpdateIncidentTotal(newTotal: number) {
            this.incidents.searchTotal = newTotal;
        },
        onApplyCwFilter(eventData: { type: string, filters: any[], page?: number }) {
            if (eventData.type === 'cw') {
                if (this.$refs.workListRef) {
                    (this.$refs.workListRef as any).onApplyFilter(eventData);
                } else {
                    // Если ref еще не доступен, ждем следующего тика
                    this.$nextTick(() => {
                        if (this.$refs.workListRef) {
                            (this.$refs.workListRef as any).onApplyFilter(eventData);
                        } else {
                            console.error('WorkList ref is not available');
                        }
                    });
                }
            }
        },
        onResetCwFilter(eventData: { type: string }) {
            if (eventData.type === 'cw' && this.$refs.workListRef) {
                (this.$refs.workListRef as any).onResetFilter(eventData);
            }
        },
        onApplyIncidentFilter(eventData: { type: string, page?: number }) {
            if (eventData.type === 'incident') {
                if (this.$refs.incidentListRef) {
                    (this.$refs.incidentListRef as any).onApplyFilter(eventData);
                } else {
                    // Если ref еще не доступен, ждем следующего тика
                    this.$nextTick(() => {
                        if (this.$refs.incidentListRef) {
                            (this.$refs.incidentListRef as any).onApplyFilter(eventData);
                        } else {
                            console.error('IncidentList ref is not available');
                        }
                    });
                }
            }
        },
        onChangeTab(type: string) {
            switch (type) {
                case "construction-work":
                    if (!this.isShowCW) {
                        // Сохраняем состояние инцидентов перед переключением
                        if (this.$refs.incidentListRef) {
                            this.savedIncidentState = (this.$refs.incidentListRef as any).getState();
                        }

                        this.isShowCW = true;
                        this.isShowIncident = false;

                        // Восстанавливаем состояние строительных работ
                        this.$nextTick(() => {
                            if (this.$refs.workListRef) {
                                if (this.savedCWState) {
                                    (this.$refs.workListRef as any).setState(this.savedCWState);
                                }
                            }
                            // Скрываем серверный блок инцидентов (так как переключились на другую вкладку)
                            if (this._blockIncident) {
                                this._blockIncident.classList.add("d-none");
                            }
                        });
                    }
                    break;
                case "incident":
                    if (!this.isShowIncident) {
                        // Сохраняем состояние строительных работ перед переключением
                        if (this.$refs.workListRef) {
                            this.savedCWState = (this.$refs.workListRef as any).getState();
                        }

                        this.isShowCW = false;
                        this.isShowIncident = true;

                        // Скрываем серверный блок строительных работ (так как переключились на другую вкладку)
                        if (this._blockCW) {
                            this._blockCW.classList.add("d-none");
                        }

                        // Восстанавливаем состояние инцидентов
                        this.$nextTick(() => {
                            if (this.$refs.incidentListRef) {
                                if (this.savedIncidentState) {
                                    (this.$refs.incidentListRef as any).setState(this.savedIncidentState);
                                } else {
                                    // При первом переключении убеждаемся, что серверный блок виден
                                    const blockIncident = document.getElementById("listIncident");
                                    if (blockIncident) {
                                        blockIncident.classList.remove("d-none");
                                    }
                                }
                            } else {
                                // Если компонент еще не смонтирован, показываем серверный блок напрямую
                                const blockIncident = document.getElementById("listIncident");
                                if (blockIncident) {
                                    blockIncident.classList.remove("d-none");
                                }
                            }
                        });
                    }
                    break;
            }
        },
    },
    async mounted() {
        await this.store.initDataForFilter();
        await this.store.iniWorkForMap();

        this.loading = false;
    },
    beforeMount() {
        const el = document.getElementById("app-construction-work");
        if (!el) return;

        const combinedMode = el.dataset.combinedMode;

        const allWorksCount = el.dataset.allWorksCount
            ? parseInt(el.dataset.allWorksCount)
            : 0;
        const unreadWorksCount = el.dataset.unreadWorksCount
            ? parseInt(el.dataset.unreadWorksCount)
            : 0;

        this.works = {
            total: allWorksCount,
            searchTotal: allWorksCount,
            list: [],
            unReadCount: unreadWorksCount,
        };

        const blockCW = document.getElementById("listConstructionWork");
        if (blockCW) {
            this._blockCW = blockCW;

            // работа с серверной пагинацией
            const navList = blockCW.querySelector(".pagination-server");
            if (navList) {
                const self = this;
                navList.addEventListener("click", function (event) {
                    const target = event.target as HTMLElement | null;
                    if (!target) return;

                    const link = target.closest("a");
                    if (!link) return;

                    event.preventDefault(); // перехватываем стандартное действие

                    const page = link.dataset.page;
                    if (page) {
                        const pageNumber = parseInt(page, 10);
                        // Вызываем onApplyCwFilter с пустыми фильтрами и указанной страницей
                        // Это переключит на Vue-пагинацию с нужной страницей
                        self.onApplyCwFilter({
                            type: 'cw',
                            filters: [],
                            page: pageNumber,
                        });
                    }
                });
            }

        }

        if (combinedMode === "true") {
            this.isCombinedMode = true;

            const blockIncident = document.getElementById("listIncident");
            if (blockIncident) {
                this._blockIncident = blockIncident;

                // работа с серверной пагинацией для инцидентов
                const navListIncident = blockIncident.querySelector(".pagination-server");
                if (navListIncident) {
                    const self = this;
                    navListIncident.addEventListener("click", function (event) {
                        const target = event.target as HTMLElement | null;
                        if (!target) return;

                        const link = target.closest("a");
                        if (!link) return;

                        event.preventDefault(); // перехватываем стандартное действие

                        const page = link.dataset.page;
                        if (page) {
                            const pageNumber = parseInt(page, 10);
                            // Вызываем onApplyIncidentFilter с указанной страницей
                            // Это переключит на Vue-пагинацию с нужной страницей
                            self.onApplyIncidentFilter({
                                type: 'incident',
                                page: pageNumber,
                            });
                        }
                    });
                }
            }

            const allIncidentCount = el.dataset.allIncidentsCount
                ? parseInt(el.dataset.allIncidentsCount)
                : 0;

            this.incidents = {
                total: allIncidentCount,
                searchTotal: allIncidentCount,
                list: [],
            };
        }
    },
    setup() {
        const store = inject<Store>("store");
        return {
            store,
        };
    },
});
